import { odinFirebaseConfig } from './configFirebase'
import { FirebaseApp, initializeApp } from 'firebase/app'

let app: FirebaseApp | undefined = undefined
const initializeOdinApp = async (): Promise<void> => {
  try {
    app = initializeApp(odinFirebaseConfig)
  } catch (err) {
    console.error(err)
  }
}

export { initializeOdinApp, app }
